import axios from 'axios';
window.axios = axios;

window.getCookie = function(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
}

const $portal = axios.create({
    withCredentials: true,
});

$portal.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${getCookie('IMC_TENDER_INTERNAL')}`;
    return config;
});

$portal.CancelToken = axios.CancelToken.source();
window.local_api = $portal;





//Internal Request
window.axios = axios;

let token = getCookie('IMC_API_TENDER')
const $api_full = axios.create({
    baseURL : "https://api.imcagro.com/api/v1/",
});

$api_full.interceptors.request.use((config) => {
    config.headers['Authorization'] = 'Bearer ' + token;
    config.headers['Accept'] = 'application/json';
    return config;
});

$api_full.CancelToken = axios.CancelToken.source();
window.api = $api_full;